import Vue from 'vue';
import ApiClient from '../client';

/**
 * Current domain organisation observable.
 * @type {Vue.Observable<CurrentDomainOrganisation>}
 */
export const currentDomainOrganisation = Vue.observable({
  value: null
});

class AppAPI extends ApiClient {

  settings=undefined;
  constructor() {
    super();
    this.getSettings();
  }

  async getCurrentDomainOrganisation() {
    try {
      const response = await this.get('current-domain-organisation/');
      if (response.status === 200) {
        currentDomainOrganisation.value = response.data;
      }
      return { data: null };
    } catch {
      return { data: null };
    }
  }
  async getSettings() {
    try {
      const response = await this.get('front_settings/');
      if (response.status === 200) {
        this.settings = response.data;
      }
      
    } catch {
      console.error('Error fetching settings');
    }
  }

  async searchKeywords(query) {
    try {
      const response = await this.get(`taggit/tags/?search=${query}`);
      if (response.status === 200) {
        return response.data;
      }
    } catch {
      return false;
    }
  }

  async getSchedulers() {
    const response = await this.get('schedulers/');
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }
}

const appAPI = new AppAPI();
export default appAPI;
